// extracted by mini-css-extract-plugin
module.exports = {"container":"_204292","badge":"_4a866d"};